import React from 'react';
import {Children} from "../models/base.models";
import {Provider} from "../contexts/Context";
import StartupTokenCleanup from "./StartupTokenCleanup";
import {SnackbarProvider} from "../contexts/SnackbarContext";

import {CssBaseline, StyledEngineProvider, ThemeProvider as MuiThemeProvider} from '@mui/material';
import {ThemeProvider as SCThemeProvider} from 'styled-components';
import {buildTheme} from "../theme/core/mui-theme";

const AppProviders = ({children}: Children): React.ReactElement => {
    const theme = buildTheme();

    return (
        <Provider>
            <StyledEngineProvider injectFirst>
                <MuiThemeProvider theme={theme}>
                    <SCThemeProvider theme={theme}>
                        <SnackbarProvider>
                            <CssBaseline/>
                            <StartupTokenCleanup/>
                            {children}
                        </SnackbarProvider>
                    </SCThemeProvider>
                </MuiThemeProvider>
            </StyledEngineProvider>
        </Provider>
    );
};

export default AppProviders;
